import {
  FC,
  // SyntheticEvent,
  useEffect,
  useContext,
  useState,
  useRef,
} from 'react';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import styled from '@mui/material/styles/styled';
import styles from './index.module.scss';
import { useAuth } from 'context/Auth';
import { useNavigate, useLocation } from 'react-router-dom';// 20230112 wilson add
import { GlobalContext } from '../../storage'; // 21.12.23 SCH
import { LINE_OFFICIAL_URL, toLiffUrl } from 'constants/externalLinks';



const DialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  marginTop: 10,
  padding: theme.spacing(1),
  textAlign: 'center',
  marginBottom: 20,
}));

const DialogContent = styled(MuiDialogContent)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  minWidth: 285,
  padding: '20px',
  paddingBottom: 28,
}));

const DialogActions = styled(MuiDialogActions)(() => ({
  padding: '0 20px',
  paddingBottom: 18,
  display: 'flex',
  flexDirection: 'column',
  '& > :not(:first-of-type)': {
    marginLeft: 0,
    marginTop: 10,
  },
}));



interface ManualModalErrorProps {
  visible: boolean;
  errorCheck: number;
  // 相機錯誤(errorCheck=1)觸發當下是否在 LIFF context(liff.isInClient())
  isInLiff?: boolean;
  // 相機錯誤觸發當下 UA 是否含 Line/(代表在 LINE app 內,但不一定 LIFF)
  inLineApp?: boolean;
  onClose?: () => void;
  // 回傳 true 代表拿到權限,dialog 自動關;false 切到 failed 階段。
  onRequestCameraPermission?: () => Promise<boolean>;
  // PG-188 相機錯誤(errorCheck=1)時的手動逃生口類型:
  //   'package'   — 通路已確定(全家 / 已選歸還點)→ 直接手動輸入包裝編號
  //   'pickPoint' — 非全家 step 0 掃不到歸還點 QR → 手動選擇歸還點(GPS 清單)
  //   undefined   — 無手動路徑(維持舊的引導 LINE 行為)
  manualMode?: 'package' | 'pickPoint';
  onManualAction?: () => void;
}

const ManualModal: FC<ManualModalErrorProps> = (props) => {
  /* eslint-disable */
  const navigate = useNavigate();
  const { visible, errorCheck, isInLiff, inLineApp, onClose, onRequestCameraPermission, manualMode, onManualAction } = props;
  const { accessToken, me } = useAuth(); 
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [packageId, setPackageId] = useState<string>();


  const inputRef = useRef<HTMLInputElement | null>(null); 
  const [epkIdFound, setEpkIdFound] = useState<boolean>(false);
  const { returnStorage } = useContext(GlobalContext); 
  const { store_id, setStoreId } = returnStorage; 
  const { chs_short_code, setChsShortCode } = returnStorage; 
  const { epk_id, setEpkId } = returnStorage; 
  const { fami_tage, setFamiTage } = returnStorage; 
  const epkId = useRef<string>(); 
  const location = useLocation();

  const { nearByStorage } = useContext(GlobalContext);
  const { me_latitude, me_longitude } = nearByStorage;
  /* eslint-enable */

  const [cameraRetryStage, setCameraRetryStage] = useState<'initial' | 'retrying' | 'failed'>('initial');

  // 重置避免上次的 failed 狀態殘留到下一次開啟
  useEffect(() => {
    if (visible) setCameraRetryStage('initial');
  }, [visible]);

  const handleCameraRetry = async () => {
    if (!onRequestCameraPermission) return;
    setCameraRetryStage('retrying');
    const ok = await onRequestCameraPermission();
    if (ok) {
      onClose && onClose();
    } else {
      setCameraRetryStage('failed');
    }
  };

  // 取得相機環境分類:用於文案與按鈕分流
  //   liff       — 已在 LIFF context,真正的 LINE 相機權限被拒
  //   line-iab   — UA 是 LINE app 但沒進 LIFF(in-app browser),webview 政策直接擋相機,點 retry 也徒勞
  //   external   — 一般瀏覽器(分享連結點來),需引導改用 LINE app
  const cameraEnv: 'liff' | 'line-iab' | 'external' =
    isInLiff ? 'liff' : inLineApp ? 'line-iab' : 'external';

  const handleOnConfirmPermissions = () => {
    //   1: camera , 2:position
    switch(errorCheck) {
      case 1:
        // PG-188 有手動逃生口時:先讓使用者用手勢重試相機,或直接走手動路徑完成歸還,不再繞回 LINE。
        if (manualMode) {
          return (
            <span>
              相機無法啟動。可先點「點我開啟相機」再試一次;
              或改用「{manualMode === 'pickPoint' ? '手動選擇歸還點' : '手動輸入包裝編號'}」完成歸還,不需要掃描。
            </span>
          );
        }
        if (cameraRetryStage === 'failed') {
          if (cameraEnv === 'line-iab') {
            return (
              <span>
                仍無法開啟相機。LINE 內建瀏覽器擋住相機權限,請點下方按鈕在 LINE 中重新開啟此頁面。
              </span>
            );
          }
          if (cameraEnv === 'external') {
            return (
              <span>
                仍無法開啟相機。請改用 LINE app 從「配客嘉」官方帳號的歸還功能進入。
              </span>
            );
          }
          return (
            <span>
              仍無法開啟相機,可能權限被永久拒絕。請至手機設定開啟 LINE 的相機權限:
              <br /><br />
              iOS:設定 → LINE → 相機
              <br />
              Android:設定 → 應用程式 → LINE → 權限 → 相機
              <br /><br />
              完成後請點「重新整理頁面」。
            </span>
          );
        }
        if (cameraEnv === 'line-iab') {
          return (
            <span>
              您目前透過 LINE 內建瀏覽器開啟此頁面,相機權限會被擋住。
              <br /><br />
              請點下方按鈕在 LINE 中重新開啟,系統跳「在 LINE 中開啟」提示時請選擇允許。
            </span>
          );
        }
        if (cameraEnv === 'external') {
          return (
            <span>
              相機無法啟動。請改用 LINE app 從「配客嘉」官方帳號的歸還功能進入歸還流程。
            </span>
          );
        }
        return '相機無法啟動,可能是相機權限尚未允許。請點下方按鈕重新嘗試。';
      case 2:
        return '歸還流程需要[ 同意 ]定位權限，請再次進入歸還流程。(＊如瀏覽器權限被鎖定，會無法執行，請洽客服協助。)';
      case 3:
        return '系統暫時無法處理，請再試一次；若持續發生請聯繫客服。'
      case 4:
        return (<p>進入配客嘉官方LINE<br/>點選「各式循環包裝掃碼歸還」進行歸還</p>)
      case 5:
        return '您的包裝今日已重複歸還'
      case 6:
        return '請掃描歸還點 QR code'
      case 7:
        return '請掃描包裝上的「包裝編號」QR code'
      case 9:
        return '目前使用人數較多，請稍候一分鐘再試。'
      case 10:
        return '此歸還點已停止收件，請改至其他歸還點歸還。'
      case 8:
        return '查無此包裝編號。請確認掃描的是包裝上的「包裝編號 QR Code」；若編號無誤仍無法歸還，請聯繫客服。'
      default:
        return '授權提示';
    }
  };

  // line-iab 情境:點下後在 LINE 中以 LIFF 模式重新開啟當前路徑,跳出 webview 限制
  const openInLineApp = () => {
    const path = (window.location.pathname || '/rent') + (window.location.search || '');
    window.location.href = toLiffUrl(path);
  };

  const openLineOfficial = () => {
    window.location.href = LINE_OFFICIAL_URL;
  };

  const renderActions = () => {
    if (errorCheck === 1) {
      // PG-188 有手動逃生口時,一律給:①手勢重試相機 ②手動路徑 ③(LINE IAB 才給)在 LINE 重開 ④取消。
      // 不再顯示只會繞回官方帳號的死循環鈕 — 真正的逃生口已經在這裡。
      if (manualMode && onManualAction) {
        return (
          <>
            {onRequestCameraPermission && (
              <button
                className={`${styles.actionButton}`}
                disabled={cameraRetryStage === 'retrying'}
                onClick={handleCameraRetry}
              >
                {cameraRetryStage === 'retrying' ? '開啟相機中…' : '點我開啟相機'}
              </button>
            )}
            <button className={`${styles.actionButton}`} onClick={onManualAction}>
              {manualMode === 'pickPoint' ? '手動選擇歸還點' : '改用手動輸入包裝編號'}
            </button>
            {cameraEnv === 'line-iab' && (
              <button className={`${styles.actionButton}`} onClick={openInLineApp}>
                在 LINE 中重新開啟
              </button>
            )}
            <button
              className={`${styles.actionButton}`}
              onClick={() => {
                onClose && onClose();
                navigate('/rent');
              }}
            >
              取消
            </button>
          </>
        );
      }
      if (cameraRetryStage === 'failed') {
        if (cameraEnv === 'line-iab') {
          return (
            <>
              <button className={`${styles.actionButton}`} onClick={openInLineApp}>
                在 LINE 中重新開啟
              </button>
              <button
                className={`${styles.actionButton}`}
                onClick={() => {
                  onClose && onClose();
                  navigate('/rent');
                }}
              >
                取消
              </button>
            </>
          );
        }
        if (cameraEnv === 'external') {
          return (
            <>
              <button className={`${styles.actionButton}`} onClick={openLineOfficial}>
                前往配客嘉 LINE 官方帳號
              </button>
              <button
                className={`${styles.actionButton}`}
                onClick={() => {
                  onClose && onClose();
                  navigate('/rent');
                }}
              >
                取消
              </button>
            </>
          );
        }
        return (
          <>
            <button
              className={`${styles.actionButton}`}
              onClick={() => window.location.reload()}
            >
              重新整理頁面
            </button>
            <button
              className={`${styles.actionButton}`}
              onClick={() => {
                onClose && onClose();
                navigate('/rent');
              }}
            >
              取消
            </button>
          </>
        );
      }
      if (cameraEnv === 'line-iab') {
        return (
          <>
            <button className={`${styles.actionButton}`} onClick={openInLineApp}>
              在 LINE 中重新開啟
            </button>
            <button
              className={`${styles.actionButton}`}
              disabled={cameraRetryStage === 'retrying'}
              onClick={handleCameraRetry}
            >
              {cameraRetryStage === 'retrying' ? '重新嘗試中…' : '仍要重試開啟相機'}
            </button>
            <button
              className={`${styles.actionButton}`}
              disabled={cameraRetryStage === 'retrying'}
              onClick={() => {
                onClose && onClose();
                navigate('/rent');
              }}
            >
              取消
            </button>
          </>
        );
      }
      if (cameraEnv === 'external') {
        return (
          <>
            <button className={`${styles.actionButton}`} onClick={openLineOfficial}>
              前往配客嘉 LINE 官方帳號
            </button>
            <button
              className={`${styles.actionButton}`}
              onClick={() => {
                onClose && onClose();
                navigate('/rent');
              }}
            >
              取消
            </button>
          </>
        );
      }
      return (
        <>
          <button
            className={`${styles.actionButton}`}
            disabled={cameraRetryStage === 'retrying'}
            onClick={handleCameraRetry}
          >
            {cameraRetryStage === 'retrying' ? '重新嘗試中…' : '重新嘗試開啟相機'}
          </button>
          <button
            className={`${styles.actionButton}`}
            disabled={cameraRetryStage === 'retrying'}
            onClick={() => {
              onClose && onClose();
              navigate('/rent');
            }}
          >
            取消
          </button>
        </>
      );
    }
    return (
      <button
        className={`${styles.actionButton}`}
        onClick={() => {
          // case 3/5/6/7/8/9 可在原頁重試,只關 dialog;case 1/2/4 無法恢復,導回 /rent
          if (errorCheck === 3 || errorCheck === 5 || errorCheck === 6 || errorCheck === 7 || errorCheck === 8 || errorCheck === 9 || errorCheck === 10) {
            onClose && onClose();
            return;
          }
          onClose && onClose();
          navigate('/rent');
        }}
      >
        確定
      </button>
    );
  };

  return (
    <Dialog open={visible} onClose={onClose}>
      <DialogTitle>
        {errorCheck === 1 && cameraRetryStage === 'failed'
          ? '仍無法開啟相機'
          : errorCheck === 3 || errorCheck === 6 || errorCheck === 7 || errorCheck === 8 || errorCheck === 9 || errorCheck === 10
            ? '錯誤訊息'
            : '授權提示'}
      </DialogTitle>
      <DialogContent>
          <div className={styles.manualContainer}>
            <span style={{textAlign:'center'}}>
              { handleOnConfirmPermissions()}
            </span>
          </div>
      </DialogContent>
      <DialogActions>
        {renderActions()}
      </DialogActions>
    </Dialog>
  );
};

export default ManualModal;
